import * as type from '../ActionTypes';

export function getAllTechnology() {
  return {
    type: type.GET_ALL_TECHNOLOGY
  };
}

export function createJobPost(payload: any) {
  return {
    type: type.CREATE_JOB_POST,
    payload: payload
  };
}

export function updateJobPost(payload: any, id: string) {
  return {
    type: type.UPDATE_JOB_POST_REQUEST,
    payload: payload,
    id
  };
}

export function clearJobPostData() {
  return {
    type: type.CLEAR_JOB_CREATION
  };
}

export function saveSelectedSkill(payload: any) {
  return {
    type: type.SAVE_SKILL_REQUEST,
    payload
  };
}
export function updateSelectedSkill(payload: any, userId: string) {
  return {
    type: type.UPDATE_SKILL_REQUEST,
    payload,
    userId
  };
}
export function saveSkillsExperience(payload: any) {
  return {
    type: type.SAVE_SKILL_EXPERIENCE_REQUEST,
    payload
  };
}
export function updateSkillsExperience(payload: any, userId: string) {
  return {
    type: type.UPDATE_SKILL_EXPERIENCE_REQUEST,
    payload,
    userId
  };
}
export function resetSkillsExperienceStatus() {
  return {
    type: type.RESET_SKILL_EXPERIENCE
  };
}

export function inviteCoder(payload: any) {
  return {
    type: type.SEND_INVITE,
    payload: payload
  };
}
export function getInviteCoder(payload: any) {
  return {
    type: type.GET_ALL_INVITES,
    payload: payload
  };
}
export function inviteCoderSuccess(payload: any) {
  return {
    type: type.SEND_INVITE_SUCCESS,
    payload: payload
  };
}

export function inviteCoderFailure(payload: any) {
  return {
    type: type.SEND_INVITE_FAILURE,
    payload: payload
  };
}

export function cleanInvitations() {
  return {
    type: type.CLEAR_JOB_INVITATIONS
  };
}

export function sendCoderProfileStatus() {
  return {
    type: type.SEND_INVITE_CODER_PROFILE_STATUS
  };
}
export function inviteSendnviteCoderStatus() {
  return {
    type: type.SEND_INVITE_CODER_STATUS
  };
}
